import create from "zustand";
import { AppStreamEmbedConstant } from "../constants";
import { DEFAULT_VISUAL_MODE } from "../constants/Toolbar";
import { Mode } from "@cloudscape-design/global-styles";

interface UseToolbarPreferenceStoreState {
  visualMode: Mode;
  streamingMode: AppStreamEmbedConstant.StreamingMode;
  displayResolution: AppStreamEmbedConstant.Resolutions;
  showFunctionKeysToolbarItem: boolean;
  useOptionKeyAsAltKey: boolean;
  useCommandAsControlKey: boolean;
  microphoneEnabled: boolean;
  webcamEnabled: boolean;
  setVisualMode: (mode: Mode) => void;
  setStreamingMode: (
    streamingMode: AppStreamEmbedConstant.StreamingMode
  ) => void;
  setDisplayResolution: (
    displayResolution: AppStreamEmbedConstant.Resolutions
  ) => void;
  setUseOptionKeyAsAltKey: (value: boolean) => void;
  setUseCommandAsControlKey: (value: boolean) => void;
  setShowFunctionKeysToolbarItem: (value: boolean) => void;
  setMicrophoneEnabled: (value: boolean) => void;
  setWebcamEnabled: (value: boolean) => void;
}

/**
 * Store for managing the preference values
 */
export const useToolbarPreferenceStore = create<UseToolbarPreferenceStoreState>(
  (set) => ({
    visualMode: DEFAULT_VISUAL_MODE,
    streamingMode: AppStreamEmbedConstant.StreamingMode.BEST_RESPONSIVENESS,
    displayResolution: AppStreamEmbedConstant.Resolutions.MATCH_LOCAL_DISPLAY,
    showFunctionKeysToolbarItem: false,
    useOptionKeyAsAltKey: false,
    useCommandAsControlKey: false,
    microphoneEnabled: false,
    webcamEnabled: false,
    setVisualMode: (visualMode) => {
      set((state) => ({
        ...state,
        visualMode,
      }));
    },
    setStreamingMode: (streamingMode) =>
      set((state) => ({
        ...state,
        streamingMode,
      })),
    setDisplayResolution: (displayResolution) =>
      set((state) => ({
        ...state,
        displayResolution,
      })),
    setUseOptionKeyAsAltKey: (value) =>
      set((state) => ({
        ...state,
        useOptionKeyAsAltKey: value,
      })),
    setUseCommandAsControlKey: (value) =>
      set((state) => ({
        ...state,
        useCommandAsControlKey: value,
      })),
    setShowFunctionKeysToolbarItem: (value) =>
      set((state) => ({
        ...state,
        showFunctionKeysToolbarItem: value,
      })),
    setMicrophoneEnabled: (value) =>
      set((state) => ({
        ...state,
        microphoneEnabled: value,
      })),
    setWebcamEnabled: (value) =>
      set((state) => ({
        ...state,
        webcamEnabled: value,
      })),
  })
);
